// types
import type { StrapiMenuLink } from '@ts-strapi/interfaces'

export const useOpenMenuLink = (): ((link: StrapiMenuLink) => void) => {
  return (link: StrapiMenuLink): void => {
    if (link.newTab) {
      window.open(link.url, '_blank', 'noopener,noreferrer')
    }
    else {
      window.location.href = link.url
    }
  }
}